<template>
  <app-layout>
    <dashboard-layout>
      <template slot="header-out">
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h1>{{ $t('Notificaciones') }}</h1>
            </v-card-title>
            <v-card-text>
              <broadcast-message-list
                entity="user-broadcast-messages/my-messages"
                config-url="/config/broadcast-messages"
                :level="1"
                search-input
                default-icon="mdi-document"
              ></broadcast-message-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import BroadcastMessageList from '../components/BroadcastMessageList.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';

import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';

export default {
  components: {
    AppLayout,
    BroadcastMessageList,
    DashboardLayout,
    MyConsultantConversation,
    CalendarEvents,
  },
};
</script>

<style lang="scss" scoped></style>
